import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Bg_Logo,  Slider_1, Slider_2, Slider_3, Slider_4, ZAKAT_LOGO } from '../../common/images-s3';
import Footer from '../../section/footer/footer';
import Home from '../home/home';
import { contributionHeader } from '../home/home';
import * as userAction from '../../redux/actions/userAction';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

const SlickSlider = () => {

  const [isHomePage, setHomePage] = useState(true)
  const user = useSelector((state) => state.userReducer)
  const headerData = user.userStepsData
  console.log(user, 'user')
  const dispatch = useDispatch()
  const settings = {
    dots: true,
    infinite: true,
    // speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    // autoplaySpeed: 3000,
    pauseOnHover: false,
    arrows: false,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ]
  };

  const slides = [
    {
      id: 1,
      image: Slider_1,
      heading: <p>Plan Your <span>Contribution</span></p>,
      subheading: 'Select what you wish to give — simple, <br/> fast, and rewarding.',
    },
    {
      id: 2,
      image: Slider_2,
      heading: <p>Fill In Your <span>Details</span></p>,
      subheading: 'Fill in your information to ensure a <br/> smooth contribution process.',
    },
    {
      id: 3,
      image: Slider_3,
      heading: <p>Receive Your <span>Instant Token</span></p>,
      subheading: 'A unique Token ID will be sent to <br/> your email or phone.',
    },
    {
      id: 4,
      image: Slider_4,
      heading: <p>Show, Pay & <span>Complete</span></p>,
      subheading: 'Share your token with the Amil and <br/> finalize your contribution swiftly.',
    },
  ];

  const handleNext = () => {
   dispatch(userAction.updateUserSteps(contributionHeader))
    setHomePage(true)
  }

  return (
    headerData.steps ? 
      <Home setHomePage={setHomePage}/> :
    <div className='sec-slider' style={{ backgroundImage: `url(${Bg_Logo})` }}>
      <div className='head-logo'><img src={ZAKAT_LOGO} /> </div>

      <div className='slider-block'>
        <Slider {...settings}>

          {slides.map(slides => (
            <div className='carousel-slider' key={slides.id}>
              <div className='inner'>
                <img src={slides.image} alt={slides.heading} className='slide-img' />
                <h3 className='sl-heading'>{slides.heading}</h3>
                <p  className='sub-heading' dangerouslySetInnerHTML={{ __html: `${slides.subheading}` }} /> 
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <Footer CustomClass="box-shadow-footer" btnName="Get Started" handleNext={handleNext} />
    </div>
  );
};

export default SlickSlider;
